// eslint-disable-next-line import/no-anonymous-default-export
export default {
  formId: "mentorForm",
  formField: {
    //Page 1
    email: {
      name: "email",
      label: "Email*",
      requiredErrorMsg: "Email is required",
      invalidErrorMsg: "Email is not valid (e.g. Test@gmail.com)",
    },
    password: {
      name: "password",
      label: "Password*",
      requiredErrorMsg: "Password is required",
    },
    academicTitle: {
      name: "academicTitle",
      label: "Academic Title",
      requiredErrorMsg: "Academic Title is required",
    },
    nameEng: {
      name: "nameEng",
      label: "Name (In English)",
      requiredErrorMsg: "Name (In English) is required",
    },
    middleNameEng: {
      name: "middleNameEng",
      label: "Middle Name (In English)",
      requiredErrorMsg: "Middle Name (In English) is required",
    },
    surnameEng: {
      name: "surnameEng",
      label: "Surname (In English)",
      requiredErrorMsg: "Surname (In English) is required",
    },
    titleNameThai: {
      name: "titleNameThai",
      label: "Title's name (In Thai)",
      requiredErrorMsg: "Title's name (In Thai) is required",
    },
    nameThai: {
      name: "nameThai",
      label: "Name (In Thai) ",
      requiredErrorMsg: "Name (In Thai)  is required",
    },
    middleNameThai: {
      name: "middleNameThai",
      label: "Middle Name (In Thai)",
      requiredErrorMsg: "Middle Name (In Thai) is required",
    },
    surnameThai: {
      name: "surnameThai",
      label: "Surname (In Thai)",
      requiredErrorMsg: "Surname (In Thai) is required",
    },

    ///////////////////////////////////////////////////////////////////////////////Page 2
    faculty: {
      name: "faculty",
      label: "Faculty / College / Institute",
      requiredErrorMsg: "Faculty / College / Institute is required",
    },
    department: {
      name: "department",
      label: "Department",
      requiredErrorMsg: "Department is required",
    },
    mobileNumber: {
      name: "mobileNumber",
      label: "Mobile Number",
      requiredErrorMsg: "Mobile Number is required",
    },
    dateOfBirth: {
      name: "dateOfBirth",
      label: "Date of Birth*",
      requiredErrorMsg: "Date of Birth is required",
    },

    ///////////////////////////////////////////////////////////////////////////////Page 3
    postdocFellowshipRecieve: {
      name: "postdocFellowshipRecieve",
      label: `How many C2F Postdoc Grantees Do You Receive from C2F? 
      (please type "0" if you don't receive)`,
      requiredErrorMsg: "Fill is required",
    },
    typeAllPostdocs: {
      name: "typeAllPostdocs",
      label: "Please Type all Postdoc Grantee's Name and Surname",
      requiredErrorMsg: "Fill is required",
    },
    postdocCurrently: {
      name: "postdocCurrently",
      label: "How Many C2F Postdoc Grantees Do You Currently Supervise?",
      requiredErrorMsg: "Fill is required",
    },
    postdocUnderSupervision: {
      name: "postdocUnderSupervision",
      label:
        "How Many C2F Postdoc Grantees Under Your Supervision Who Received C2F Payment and Resigned Before the Contract End?",
      requiredErrorMsg: "Fill is required",
    },
    resignedPostdoc: {
      name: "resignedPostdoc",
      label:
        "Did the Resigned Postdoc Grantee Make a Clearance Status with C2F? (e.g. paid back the fellowship to C2F)",
      requiredErrorMsg: "Fill is required",
    },
    phdScholarship: {
      name: "phdScholarship",
      label: "How Many C2F PhD Scholarship Do You Receive from C2F?",
      requiredErrorMsg: "Fill is required",
    },
    allPhDStudents: {
      name: "allPhDStudents",
      label: "Please Indicate All PhD students Grantees' Name and Surname",
      requiredErrorMsg: "Fill is required",
    },
    phdStudents: {
      name: "phdStudents",
      label: "How Many C2F PhD Student Grantees Do You Currently Supervise?",
      requiredErrorMsg: "Fill is required",
    },
    studentUnderSupervision: {
      name: "studentUnderSupervision",
      label:
        "How Many C2F PhD Student Grantees Under Your Supervision Who Received C2F Payment and Resigned Before the Contract End?",
      requiredErrorMsg: "Fill is required",
    },
    resignedStudent: {
      name: "resignedStudent",
      label:
        "Did the Resigned Student Make a Clearance Status with C2F? (e.g. paid back the scholarship to C2F)",
      requiredErrorMsg: "Fill is required",
    },
  },
};
